var _a;
import { ErrorType } from "../types/ErrorType";
var TITLE_CREATE_ERROR_MESSAGE_IDS = (_a = {},
    _a[ErrorType.ONE_OFF_PUBLISHER_CANNOT_CREATE_TITLE] = "ui-br-agency.title.error.oneOffPublisherCannotCreate",
    _a);
var GENERIC_TITLE_CREATE_ERROR_ID = "ui-br-agency.title.error.submit";
/** Maps a backend error code of a failed title create to a translation id. */
export var resolveTitleCreateErrorMessageId = function (code) {
    var _a;
    return (_a = (code && TITLE_CREATE_ERROR_MESSAGE_IDS[code])) !== null && _a !== void 0 ? _a : GENERIC_TITLE_CREATE_ERROR_ID;
};
